import { atom, useAtom } from 'jotai';
import { ServerStepGroup } from '../../../ServerWorkflowType';
import { collectAffectedIdsByDeletion } from '../../../workflowTreeUtils';

// Global atom to share removable IDs state across all StepGroup components
const removableIdsAtom = atom<number[]>([]);

/**
 * Hook for managing highlight state of nodes that would be affected by deletion.
 * Uses a global Jotai atom to ensure all components share the same highlight state.
 *
 * @returns Functions to handle mouse events and check if a node should be highlighted
 */
export const useHighlightRemovable = () => {
  const [removableIds, setRemovableIds] = useAtom(removableIdsAtom);

  const handleMouseEnter = ({
    ServerStepGroup,
    targetId,
  }: {
    ServerStepGroup: ServerStepGroup | null;
    targetId: number | null;
  }) => {
    const { workflowRemovableStepGroupIds, workflowRemovableStepIds } =
      collectAffectedIdsByDeletion(ServerStepGroup, targetId);

    setRemovableIds([
      ...workflowRemovableStepGroupIds,
      ...workflowRemovableStepIds,
    ]);
  };

  const handleMouseLeave = () => {
    setRemovableIds([]);
  };

  const isHighlightedAsRemovable = (targetId: number | null): boolean => {
    if (targetId === null || targetId === undefined) {
      return false;
    }
    return removableIds.includes(targetId);
  };

  return {
    handleMouseEnter,
    handleMouseLeave,
    isHighlightedAsRemovable,
    setRemovableIds,
  };
};
